document.addEventListener("DOMContentLoaded", async () => {
  let wasRestrictedAge = false;
  const weekElement = document.querySelector('.funding_total_week');
  const weekText = weekElement.textContent;
  const WEEK = parseInt(weekText, 10);
  const checkbox = document.querySelector(".field_enable_disable");
  const jsonUrl = document.getElementById("data_json_url").dataset.url;
  let activeDiscount = null;

  try {
    const response = await fetch(jsonUrl);
    const data = await response.json();
    const discountRules = data.discount_percentage || [];
    let nhsDiscount = 0;
    let siblingDiscount = 0;

    discountRules.forEach(rule => {
      if (rule.nhs !== undefined) nhsDiscount = rule.nhs;
      if (rule.sibling !== undefined) siblingDiscount = rule.sibling;
    });

    const startDates = data.dates || [];
    let startDate = "";
    let endDate = "";
    startDates.forEach((date) => {
      if (date.start_date !== undefined) startDate = date.start_date;
      if (date.end_date !== undefined) endDate = date.end_date;
    });

    const applicationStart = document.querySelector(".start_date h3");
    const applicationEnd = document.querySelector(".end_date h3");
    
    // --- DOM References ---
    const dailyFeeContainer = document.querySelector(".daily_fees");
    const monthlyContainer = document.querySelector(".monthly_bill");
    const annualSavingContainer = document.querySelector(".included");
    const errorBox = document.querySelector(".error_box");
    const calcScreen1 = document.querySelector(".calc_screen_1");
    const calcScreen2 = document.querySelector(".calc_screen_2");
    const calcScreen3 = document.querySelector(".calc_screen_3");
    const calcScreen4 = document.querySelector(".calc_screen_4");
    const calcScreen5 = document.querySelector(".calc_screen_5");
    const calcScreen6 = document.querySelector(".calc_screen_6");
    const calcScreen7 = document.querySelector(".calc_screen_7");
    const calcScreen8 = document.querySelector(".calc_screen_8");
    const final_screen = document.querySelector(".calc_screen_final");
    const screen_btn_1 = document.querySelector(".calc_btn");
    const screen_btn_2 = document.querySelector(".screen_btn_2");
    const screen_btn_3 = document.querySelector(".screen_btn_3");
    const screen_btn_4 = document.querySelector(".screen_btn_4");
    const screen_btn_5 = document.querySelector(".screen_btn_5");
    const screen_btn_6 = document.querySelector(".screen_btn_6");
    const screen_btn_7 = document.querySelector(".screen_btn_7");
    const screen_btn_8 = document.querySelector(".screen_btn_8");
    
    const back_to_1 = document.querySelector(".screen_btn_2_to_1");
    const back_to_2 = document.querySelector(".screen_btn_3_to_2");
    const back_to_3 = document.querySelector(".screen_btn_4_to_3");
    const back_to_4 = document.querySelector(".screen_btn_5_to_4");
    const back_to_5 = document.querySelector(".screen_btn_6_to_5");
    const back_to_6 = document.querySelector(".screen_btn_7_to_6");
    const back_to_7 = document.querySelector(".screen_btn_8_to_7");
    const back_to_8 = document.querySelector(".screen_btn_final_to_8");
    const totalSaving = document.querySelector(".total_saving");
    
    // --- Get nursery from URL ---
    const urlParams = new URLSearchParams(window.location.search);
    const nurseryFromUrl = urlParams.get("nursery");
    
    if (applicationStart && applicationEnd) {
      applicationStart.innerHTML = startDate;
      applicationEnd.innerHTML = endDate;
    }
    
    if (!nurseryFromUrl) {
      console.error("No nursery found in URL");
    } else {
    }

    function updateSummaryFeesByAge() {
      const summeryFee = data.summery_daily_fee[0];
      const nurseryKey = nurseryFromUrl.toLowerCase();
      if (!summeryFee[nurseryKey]) return;
      const age = calculateChildAge(); 
      if (!age) return;

      const nurseryFeeArray = summeryFee[nurseryKey];
      const matchedFee = nurseryFeeArray.find(fee =>
        age.min >= fee.months[0] && age.max <= fee.months[1]
      );

      if (!matchedFee) {
        console.warn("No matching summary fee for age band", age);
        return;
      }

      const feeMap = {
        core: "fee_core",
        extended: "fee_extended",
        food: "fee_food",
        consumables: "fee_consumables",
        activities: "fee_activities",
      };

      Object.keys(feeMap).forEach((key) => {
        const el = document.querySelector(`.${feeMap[key]}`);
        if (el && matchedFee[key] !== undefined) {
          el.innerHTML = `<b>£${matchedFee[key].toFixed(2)}</b>`;
        }
      });
    }
    //--Disable 15 Hours Funding for 9-23 age Child--//
    // function updateFundingOptionsByAge() {
    //   const govSubsidy = document.querySelector(
    //     'input[name="gov_subsidy"]:checked'
    //   )?.value;

    //   if (govSubsidy === "no") return;

    //   const age = calculateChildAge();
    //   if (!age) return;

    //   const isRestrictedAge = age.min === 9 && age.max === 23;

    //   const hour15 = document.querySelector('input[name="gov_hours"][value="15"]');
    //   const hour30 = document.querySelector('input[name="gov_hours"][value="30"]');

    //   const hour15Final = document.querySelector('input[name="gov_hours_final"][value="15"]');
    //   const hour30Final = document.querySelector('input[name="gov_hours_final"][value="30"]');

    //   // ---------- AGE = 9–23 (FORCE RULE) ----------
    //   if (isRestrictedAge) {
    //     // Disable 15
    //     [hour15, hour15Final].forEach(el => {
    //       if (!el) return;
    //       el.checked = false;
    //       el.disabled = true;
    //       el.closest("label")?.classList.add("disabled_option");
    //     });

    //     // Force 30
    //     [hour30, hour30Final].forEach(el => {
    //       if (!el) return;
    //       el.checked = true;
    //       el.closest("label")?.classList.add("active_btn_back");
    //     });

    //     // Mark that 30 was auto-forced
    //     hour30?.setAttribute("data-auto", "true");
    //     hour30Final?.setAttribute("data-auto", "true");

    //     return;
    //   }

    //   // ---------- OTHER AGES ----------
    //   // Enable 15 again
    //   [hour15, hour15Final].forEach(el => {
    //     if (!el) return;
    //     el.disabled = false;
    //     el.closest("label")?.classList.remove("disabled_option");
    //   });

    //   // 🔑 Detect if 30 was auto-forced earlier
    //   const autoForced =
    //     hour30?.getAttribute("data-auto") === "true" ||
    //     hour30Final?.getAttribute("data-auto") === "true";

    //   if (autoForced) {
    //     // Reset to default 15
    //     [hour30, hour30Final].forEach(el => {
    //       if (!el) return;
    //       el.checked = false;
    //       el.removeAttribute("data-auto");
    //     });

    //     [hour15, hour15Final].forEach(el => {
    //       if (!el) return;
    //       el.checked = true;
    //       el.closest("label")?.classList.add("active_btn_back");
    //     });
    //   }
    // }
    function updateFundingOptionsByAge() {
      const age = calculateChildAge();
      if (!age) return;

      const govSubsidy =
        document.querySelector('input[name="gov_subsidy"]:checked')?.value || "no";

      const hour15 = document.querySelector('input[name="gov_hours"][value="15"]');
      const hour30 = document.querySelector('input[name="gov_hours"][value="30"]');
      const hour15Final = document.querySelector('input[name="gov_hours_final"][value="15"]');
      const hour30Final = document.querySelector('input[name="gov_hours_final"][value="30"]');

      const allHours = [hour15, hour30, hour15Final, hour30Final].filter(Boolean);

      // -------------------------------
      // RESET VISUAL STATE
      // -------------------------------
      allHours.forEach(el => {
        el.disabled = false;
        el.closest("label")?.classList.remove("disabled_option", "active_btn_back");
      });

      // -------------------------------
      // FUNDING = NO → DISABLE ALL
      // -------------------------------
      if (govSubsidy === "no") {
        allHours.forEach(el => {
          el.checked = false;
          el.disabled = true;
          el.closest("label")?.classList.add("disabled_option");
        });
        wasRestrictedAge = false;
        return;
      }

      const isRestrictedAge = age.min === 9 && age.max === 23;

      // -------------------------------
      // AGE 9–23 → FORCE 30
      // -------------------------------
      if (isRestrictedAge) {
        wasRestrictedAge = true;

        [hour15, hour15Final].forEach(el => {
          if (!el) return;
          el.checked = false;
          el.disabled = true;
          el.closest("label")?.classList.add("disabled_option");
        });

        [hour30, hour30Final].forEach(el => {
          if (!el) return;
          el.checked = true;
          el.closest("label")?.classList.add("active_btn_back");
        });

        return;
      }

      // -------------------------------
      // LEAVING 9–23 AGE BAND
      // -------------------------------
      if (wasRestrictedAge) {
        // 🔑 Reset to 15 when age changes away from 9–23
        wasRestrictedAge = false;

        [hour30, hour30Final].forEach(el => {
          if (!el) return;
          el.checked = false;
        });

        [hour15, hour15Final].forEach(el => {
          if (!el) return;
          el.checked = true;
          el.closest("label")?.classList.add("active_btn_back");
        });

        return;
      }

      // -------------------------------
      // OTHER AGES (NORMAL FLOW)
      // -------------------------------
      // Default 15 if nothing selected
      if (
        !document.querySelector('input[name="gov_hours"]:checked') &&
        !document.querySelector('input[name="gov_hours_final"]:checked')
      ) {
        [hour15, hour15Final].forEach(el => {
          if (!el) return;
          el.checked = true;
          el.closest("label")?.classList.add("active_btn_back");
        });
      }
    }

    
    const nurseryDisplay = document.querySelector(".nursery_display");
    if (nurseryDisplay) nurseryDisplay.textContent = nurseryFromUrl;

    function calculateChildAge() {
      const selected = document.querySelector(
        'input[name="age-of-child"]:checked'
      );
      if (!selected) return null;

      const min = parseInt(selected.dataset.min, 10);
      const max = parseInt(selected.dataset.max, 10);

      return { min, max };
    }
      document
    .querySelectorAll('input[name="age-of-child"]')
    .forEach((radio) => {
      radio.addEventListener("change", () => {
        updateFundingOptionsByAge();
      });
    });

    function getPreferredDays() {
      const selected = document.querySelector(
        'input[name="preferred_days"]:checked'
      );
      return selected ? parseInt(selected.value, 10) : 0;
    }

    function updateGovSubsidy() {
      const checked = document.querySelector(
        'input[name="gov_subsidy"]:checked'
      );
      const govSubsidy = checked ? checked.value : "no";
      const hoursContainer = document.querySelector(".gov_subsidy_hours");

      if (govSubsidy === "yes") {
        hoursContainer.classList.add("hours_active");
        const first = document.querySelector(
          'input[name="gov_hours"][value="15"]'
        );
        if (first && !document.querySelector('input[name="gov_hours"]:checked'))
          first.checked = true;
      } else {
        hoursContainer.classList.remove("hours_active");
      }
      
      return govSubsidy;
    }
      document.querySelectorAll('input[name="gov_subsidy"]').forEach((radio) => {
        radio.addEventListener("change", () => {
          updateGovSubsidy();
          updateFundingOptionsByAge();
        });
      });


    function updateGovHours() {
      const govSubsidy = document.querySelector(
        'input[name="gov_subsidy"]:checked'
      );
      const isSubsidyYes = govSubsidy && govSubsidy.value === "yes";

      if (!isSubsidyYes) return 0;

      const checkedHour = document.querySelector(
        'input[name="gov_hours"]:checked'
      );

      const age = calculateChildAge();
      if (age && age.min === 9 && age.max === 23 && checkedHour?.value === "15") {
        return 0; // force invalid selection off
      }

      return checkedHour ? parseInt(checkedHour.value, 10) : 0;
    }


    function getSavingsFromJSON(row) {
      return row.hasOwnProperty("savings") ? row.savings : 0;
    }

    // --- Dynamic filter function ---

    function filterFunction(months, preferredDays, govSubsidyHours, nursery) {
      let funding = govSubsidyHours > 0 ? String(govSubsidyHours) : "None";

      let filtered = data.rows
        .filter((r) => r.nursery === nursery)

        // ★ Exact match JSON age band
        .filter((r) => r.months[0] === months.min && r.months[1] === months.max)

        .filter((r) => r.days === preferredDays)
        .filter((r) => r.funding === funding);

      if (filtered.length === 0) {
        console.warn("⚠️ No matching data");
        errorBox.innerHTML = "No data available for this combination.";
        return null;
      }

      const match = filtered[0];
      const saving = getSavingsFromJSON(match);

      totalSaving.innerHTML = formatGBP(saving);
      // totalSaving.innerHTML = `£${saving.toFixed(2)}`;
      dailyFeeContainer.innerHTML = `£${match.daily}`;
      monthlyContainer.innerHTML = `£${match.monthly}`;
      annualSavingContainer.innerHTML = `£${saving}`;

      return { match, saving };
    }
    // Price Formate ex: 5,675.00
    function formatGBP(amount) {
      return `£${amount.toLocaleString('en-GB', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;
    }



    function scrollToFees() {
      let target;

      if (window.innerWidth < 768) {
        target = document.getElementById("content-fees");
      } else {
        target = document.getElementById("scroll_top");
      }

      if (!target) return;
      target.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
    //backs btns//
    back_to_1.addEventListener('click',function(){
      calcScreen2.classList.remove("screen_active");
      calcScreen1.classList.add("screen_active");
      scrollToFees();
    })
    back_to_2.addEventListener('click',function(){
      calcScreen3.classList.remove("screen_active");
      calcScreen2.classList.add("screen_active");
      scrollToFees();
    })
    back_to_3.addEventListener('click',function(){
      calcScreen4.classList.remove("screen_active");
      calcScreen3.classList.add("screen_active");
      scrollToFees();
    })
    back_to_4.addEventListener('click',function(){
      calcScreen5.classList.remove("screen_active");
      calcScreen4.classList.add("screen_active");
      scrollToFees();
    })
    back_to_5.addEventListener('click',function(){
      calcScreen6.classList.remove("screen_active");
      calcScreen5.classList.add("screen_active");
      scrollToFees();
    })
    back_to_6.addEventListener('click',function(){
      calcScreen7.classList.remove("screen_active");
      calcScreen6.classList.add("screen_active");
      scrollToFees();
    })
    back_to_7.addEventListener('click',function(){
      calcScreen8.classList.remove("screen_active");
      const govSub = updateGovSubsidy();
      if (govSub === "no") {
        calcScreen1.classList.add("screen_active");     
        scrollToFees();
        return;
      }
      calcScreen7.classList.add("screen_active");
      scrollToFees();
    })
    back_to_8.addEventListener('click',function(){
      final_screen.classList.remove("screen_active");
      calcScreen8.classList.add("screen_active");
      scrollToFees();
    })

    // --- First Screen 1 calculate button ---
    screen_btn_1.addEventListener("click", () => {
      let btnDiv = document.querySelector(".btn_wrap");
      updateFundingOptionsByAge();
      const months = calculateChildAge();
      const selectedAge = document.querySelector(
        'input[name="age-of-child"]:checked'
      );
      const subtileMain = document.querySelector('.main_sub_text_calc');  
      const mainTitle = document.querySelector('.tab_child_name_param');
      const preferredDays = getPreferredDays();
      const govSubsidy = updateGovSubsidy();
      const govSubsidyHours = updateGovHours();
      const discountBtns = document.querySelector(".left_discount");
      if(discountBtns){
        if (govSubsidy == "yes") {
          discountBtns.style.display = "none";
        } else {
          discountBtns.style.display = "block";
        }
      }
      const nursery = nurseryFromUrl;
      const day = document.querySelector(".start-day");
      const month = document.querySelector(".start-month");
      const year = document.querySelector(".start-year");

      subtileMain.classList.add('hide_subtitle');
      mainTitle.classList.add('new_main_calc_title');
      
      if (!nursery || nursery === "Nursery")
        return (errorBox.innerHTML = `Please select a nursery.`);
      if (!selectedAge)
        return (errorBox.innerHTML = `Please Select Child Age.`);
      if (day.value == "" || month.value == "" || year.value == "")
        return (errorBox.innerHTML = `Please Enter Start Date.`);

      filterFunction(months, preferredDays, govSubsidyHours, nursery);

      calcScreen1.classList.remove("screen_active");

      if (govSubsidy === "no") {
        calcScreen8.classList.add("screen_active");
        syncFinalScreenState();             
        updateFundingOptionsByAge();       
        // lockFinalGovHoursIfNoSubsidy();     
        hideContentClass();
        scrollToFees();
        return;
      }

      calcScreen2.classList.add("screen_active");
      updateSummaryFeesByAge();
      scrollToFees(); 

    });
    function hideContentClass(){
      const config = JSON.parse(
      document.getElementById("calculator-data-hide").textContent
      );
      let hideContentClasses = config.hideContent;
      if (hideContentClasses) {
        hideContentClasses
          .split(",")                
          .map(cls => cls.trim())    
          .filter(Boolean)           
          .forEach(cls => {
            const el = document.querySelector(`.${cls}`);
            if (el) {
              el.style.display = "none";
            }
          });
      }
    }
    // --- Funding Applied Screen 2 (spreaded hours) ---
    screen_btn_2.addEventListener("click", () => {
      calcScreen2.classList.remove("screen_active");
      calcScreen3.classList.add("screen_active");
      scrollToFees(); 
      attachPreferredDayListeners();
      const govSubsidyHours = updateGovHours();
      const colWrappers = document.querySelectorAll(".col_wrapper");
      const totalAnnualHour = document.querySelector(
        ".total_annual_funded_hour"
      );
      
      const spreadHourContainer = document.querySelector(".spread_hour");
      let totalHourYear = 0;
      let selectedHour = document.querySelector(".selected_hours");
      selectedHour.innerHTML = `${govSubsidyHours}`;
      colWrappers.forEach((col) => {
        const selectedHourEl = col.querySelector(".selected_hours");
        const termWeekEl = col.querySelector(".terms_week");
        const termTotalEl = col.querySelector(".term_total_hours");

        const termWeek = parseFloat(termWeekEl.textContent) || 0;
        const totalHour = govSubsidyHours * termWeek;

        selectedHourEl.innerHTML = govSubsidyHours;
        termTotalEl.innerHTML = totalHour;
        totalHourYear += totalHour;
      });

      totalAnnualHour.innerHTML = totalHourYear;
      const spreadedHour = (totalHourYear / WEEK).toFixed(2);
      spreadHourContainer.innerHTML = spreadedHour;
      
    });
    function attachPreferredDayListeners() {
      document.addEventListener("change", function (e) {
        if (e.target.matches(".days_p_final")) {
          finalPageCalculation();
        }
      });
    }
    screen_btn_3.addEventListener("click", () => {
      calcScreen3.classList.remove("screen_active");
      calcScreen4.classList.add("screen_active");
      scrollToFees(); 
    });
    screen_btn_4.addEventListener("click", () => {
      calcScreen4.classList.remove("screen_active");
      calcScreen5.classList.add("screen_active");
      scrollToFees(); 
    });
    screen_btn_5.addEventListener("click", () => {
      calcScreen5.classList.remove("screen_active");
      calcScreen6.classList.add("screen_active");
      scrollToFees(); 
    });
    screen_btn_6.addEventListener("click", () => {
      calcScreen6.classList.remove("screen_active");
      calcScreen7.classList.add("screen_active");
      scrollToFees(); 
    });
    screen_btn_7.addEventListener("click", () => {
      calcScreen7.classList.remove("screen_active");
      calcScreen8.classList.add("screen_active");
      scrollToFees(); 
    });

    // --- Final Page ---
    function getFinalPageGovHours() {
      const checked = document.querySelector(
        'input[name="gov_hours_final"]:checked'
      );
      return checked ? parseInt(checked.value, 10) : 0;
    }

    function getFinalPagePreferredDays() {
      const selected = document.querySelector(
        'input[name="preferred_days_final"]:checked'
      );
      return selected ? parseInt(selected.value, 10) : 0;
    }

    function finalPageCalculation() {
      const months = calculateChildAge();
      const preferredDays = getFinalPagePreferredDays();
      const govSubsidyHours = getFinalPageGovHours();

      // const nursery = nurserySelect.value;
      const nursery = nurseryFromUrl;

      // --- Run the base filter to get the original match ---
      const result = filterFunction(
        months,
        preferredDays,
        govSubsidyHours,
        nursery
      );
      if (!result) return;
      let { match, saving } = result;

      let finalDaily = match.daily.toFixed(2);
      let finalMonthly = match.monthly.toFixed(2);
      let finalSaving = match.savings ?? saving;

      // ---------------------------
      // CHECK IF row has "discount" field
      // ---------------------------
      let discountData = match.discount;

      const hasDiscount =
        discountData &&
        Array.isArray(discountData) &&
        discountData.length > 0 &&
        typeof discountData[0] === "object";

      // If NO discount in row → NHS/Sibling should do nothing
      if (!hasDiscount || discountData === "NA") {
        dailyFeeContainer.innerHTML = `£${finalDaily}`;
        monthlyContainer.innerHTML = `£${finalMonthly}`;
        annualSavingContainer.innerHTML = `£${finalSaving}`;
        return;
      }

      const availableDiscounts = discountData[0];

      // ---------------------------
      // APPLY NHS OR SIBLING VALUES (only if selected)
      // ---------------------------
      if (activeDiscount === "nhs" && availableDiscounts.nhs) {
        finalDaily = (availableDiscounts.nhs.daily).toFixed(2);
        finalMonthly = (availableDiscounts.nhs.monthly).toFixed(2);
        finalSaving = availableDiscounts.nhs.savings;
      }

      if (activeDiscount === "sibling" && availableDiscounts.sibling) {
        finalDaily = (availableDiscounts.sibling.daily).toFixed(2);
        finalMonthly = (availableDiscounts.sibling.monthly).toFixed(2);
        finalSaving = availableDiscounts.sibling.savings;
      }

      // ---------------------------
      // UPDATE UI
      // ---------------------------
      dailyFeeContainer.innerHTML = `£${finalDaily}`;
      monthlyContainer.innerHTML = `£${finalMonthly}`;
      annualSavingContainer.innerHTML = `£${finalSaving}`;
    }
    //---NHS/Sibling Discount radios----//
    function attachDiscountListeners() {
      const radios = document.querySelectorAll(
        'input[name="nhs"], input[name="sibling"]'
      );

      radios.forEach((radio) => {
        radio.addEventListener("click", () => {
          const includeDiscount = document.querySelector(
            ".include_discount_content"
          );
          const includeDiscountPercentage = document.querySelector(
            ".percentage"
          );
          console.log(includeDiscountPercentage)
          
          const selectedValue = radio.name; 
          const sameClicked = activeDiscount === selectedValue;

          
          if (sameClicked) {
            activeDiscount = null;
            radio.checked = false;

            document
              .querySelectorAll(".discount_wrapper label")
              .forEach((l) => l.classList.remove("active_btn_back"));

            includeDiscount.classList.remove(
              "nhs_discount",
              "sibling_discount"
            );
            includeDiscountPercentage.textContent = "";

            finalPageCalculation();
            return;
          }

          // --- SELECT NEW DISCOUNT ---
          activeDiscount = selectedValue;

          document
            .querySelectorAll('input[name="nhs"], input[name="sibling"]')
            .forEach((r) => {
              r.checked = r.name === selectedValue;
            });

          document
            .querySelectorAll(".discount_wrapper label")
            .forEach((l) => l.classList.remove("active_btn_back"));

          radio.closest("label").classList.add("active_btn_back");

          includeDiscount.classList.remove(
            "nhs_discount",
            "sibling_discount"
          );

          if (selectedValue === "nhs") {
            includeDiscount.classList.add("nhs_discount");
            includeDiscountPercentage.textContent = `${nhsDiscount}`;
          }

          if (selectedValue === "sibling") {
            includeDiscount.classList.add("sibling_discount");
            includeDiscountPercentage.textContent = `${siblingDiscount}`;
          }

          finalPageCalculation();
        });
      });
    }
    attachDiscountListeners()
    //--Sync Function ---///
    function syncFinalScreenState() {
      // --- Sync preferred days ---
      const firstPreferred = document.querySelector(
        'input[name="preferred_days"]:checked'
      );

      if (firstPreferred) {
        const sameFinal = document.querySelector(
          `input[name="preferred_days_final"][value="${firstPreferred.value}"]`
        );

        if (sameFinal) sameFinal.checked = true;

        document
          .querySelectorAll(".prefrred_days_wrapper label")
          .forEach((label) => label.classList.remove("active_btn_back"));

        if (sameFinal) {
          const label = sameFinal.closest("label");
          if (label) label.classList.add("active_btn_back");
        }
      }

      // --- Sync gov subsidy hours ---
      const govSubsidy = document.querySelector(
        'input[name="gov_subsidy"]:checked'
      )?.value;

      const firstGovHour = document.querySelector(
        'input[name="gov_hours"]:checked'
      );

      let finalValue = "0";

      if (govSubsidy === "yes") {
        if (firstGovHour && (firstGovHour.value === "15" || firstGovHour.value === "30")) {
          finalValue = firstGovHour.value;
        }
      }

      const sameGovFinal = document.querySelector(
        `input[name="gov_hours_final"][value="${finalValue}"]`
      );

      if (sameGovFinal) sameGovFinal.checked = true;

      document
        .querySelectorAll(".gov_hour_wrapper label")
        .forEach((label) => label.classList.remove("active_btn_back"));

      if (sameGovFinal) {
        const label = sameGovFinal.closest("label");
        if (label) label.classList.add("active_btn_back");
      }

      // --- Run final calculation after sync ---
      finalPageCalculation();
    }

    // //--Disable Final Page Hours Btns--//
    // Already Handle in updateFundingOptionsByAge() function 
    // function lockFinalGovHoursIfNoSubsidy() {
    //   const govSubsidy = document.querySelector(
    //     'input[name="gov_subsidy"]:checked'
    //   )?.value;

    //   const hour15Final = document.querySelector('input[name="gov_hours_final"][value="15"]');
    //   const hour30Final = document.querySelector('input[name="gov_hours_final"][value="30"]');

    //   if (!hour15Final || !hour30Final) return;

    //   // ---- NO GOVERNMENT FUNDING ----
    //   if (govSubsidy === "no") {
    //     [hour15Final, hour30Final].forEach(el => {
    //       el.checked = false;
    //       el.disabled = true;
    //       el.closest("label")?.classList.add("disabled_option");
    //       el.closest("label")?.classList.remove("active_btn_back");
    //     });

    //     return;
    //   }

    //   // ---- GOVERNMENT FUNDING = YES ----
    //   [hour15Final, hour30Final].forEach(el => {
    //     el.disabled = false;
    //     el.closest("label")?.classList.remove("disabled_option");
    //   });
    // }

    // --- Event Listeners ---
    screen_btn_8.addEventListener("click", function () {
      calcScreen8.classList.remove("screen_active");
      final_screen.classList.add("screen_active");
      updateFundingOptionsByAge();
      syncFinalScreenState();
      finalPageCalculation();
      scrollToFees(); 
    });

    document
      .querySelectorAll('input[name="gov_hours_final"]')
      .forEach((r) => r.addEventListener("change", finalPageCalculation));
        document
          .querySelectorAll(".days_p_final")
          .forEach((pd) => pd.addEventListener("change", finalPageCalculation));
      } catch (err) {
        console.error("Failed to load JSON", err);
      }
        let activeBtn = document.querySelectorAll(".final_page_consult_btn");
        let fundingActive = document.querySelectorAll(".gov_hour_btn");
        let prefrredDayActive = document.querySelectorAll(".pre_day_hour_btn");
        if (activeBtn.length > 0) {
          activeBtn[0].classList.add("active_btn");
        }

      // handle click events
      activeBtn.forEach((btn) => {
        btn.addEventListener("click", function () {
          activeBtn.forEach((b) => b.classList.remove("active_btn"));

          btn.classList.add("active_btn");
        });
      });
      fundingActive.forEach((btn) => {
        btn.addEventListener("click", function () {
          fundingActive.forEach((b) => b.classList.remove("active_btn_back"));

          btn.classList.add("active_btn_back");
        });
      });
      prefrredDayActive.forEach((btn) => {
        btn.addEventListener("click", function () {
          prefrredDayActive.forEach((b) => b.classList.remove("active_btn_back"));

          btn.classList.add("active_btn_back");
        });
    });

    const planToggleBtn = document.querySelector('.customize_plan_title');
    const planTogglecontainer = document.querySelector('.custimize_plan_wrapper');
    const mainLeftContainerClass= document.querySelector('.fee_coloumn_wrapper');
    let moved = false;
    if(!planToggleBtn) return;
    let leftContact = document.querySelector('.left_contact_detail');
    let colom_1 = document.querySelector('.col1_wrap');
    let colom_2 = document.querySelector('.col2_wrap');

    function isMobile() {
      return window.innerWidth < 768;
    }

    planToggleBtn.addEventListener('click', function () {
      if (isMobile()) {
        planTogglecontainer.classList.toggle('toggle_container');
        mainLeftContainerClass.classList.toggle('main_left_calc');
      }
    });
    if (isMobile()) {
    if(!moved){
          colom_2.appendChild(leftContact)
          
          moved = true;
        } else {
          colom_1.appendChild(leftContact)
          moved = false;
        }
        console.log("Moved:", moved);
      }
  updateFundingOptionsByAge();
  updateGovSubsidy();
});